/* eslint-disable @typescript-eslint/ban-ts-comment */
import { useCallback } from 'react';
import { Form, Formik } from 'formik';

import { Button } from '@febos-io/design';

import { useModalContext } from '../../../providers';
import ModalDialog from '../../ModalDialog';
import { useTranslation } from '../../../hooks';
import FilterIdentification from '../../ListFilter/input/FilterIdentification';
import FilterInput from '../../ListFilter/input/FilterInput';
import FilterListCheck from '../../ListFilter/input/FilterListCheck';
import FilterSelect from '../../ListFilter/input/FilterSelect';
import FilterDate from '../../ListFilter/input/FilterDate';
import FilterDateRange from '../../ListFilter/input/FilterDateRange';
import FilterEmail from '../../ListFilter/input/FilterEmail';
import { FilterTypes, ItemFiltered } from '../types';

export function TableModalFilters() {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const { closeModal, modalPayload } = useModalContext();
  const { t } = useTranslation();

  const handleAddFilter = useCallback(({ id, values, type, key }: ItemFiltered) => {
    modalPayload.addFilter({
      id,
      values,
      type,
      key
    });
  }, []);

  const addFilter = useCallback(
    (filter) => {
      let values = filter[modalPayload.id];
      if (typeof values === 'string' || typeof values === 'number') {
        values = [values];
      }
      if (!Array.isArray(values)) {
        values = [values];
      }
      const config = {
        values,
        type: modalPayload.config.type,
        key: modalPayload.config.key,
        id: modalPayload.id,
      }
      handleAddFilter(config);
      return closeModal();
    },
    [modalPayload.id, modalPayload.config.type, modalPayload.id, handleAddFilter, closeModal]
  );

  return (
    <ModalDialog useBackdropClose useCloseModal size="md" title={`${t('Filter by')} ${t(modalPayload.config.name)}`}>
      <div className="modal-body">
        <Formik
          initialValues={{
            [modalPayload.id]: modalPayload.actualValue || []
          }}
          validate={(values) => {
            if (!values[modalPayload.id]) {
              return { [modalPayload.id]: 'Required' };
            }
            const errors = {};
            return errors;
          }}
          onSubmit={addFilter}
        >
          <Form>
            <div className="mt-3">
              {modalPayload.config.type === FilterTypes.IDENTIFICATION && (
                <FilterIdentification name={modalPayload.id} config={modalPayload.config} />
              )}
              {modalPayload.config.type === FilterTypes.MULTI_SELECT && (
                <FilterSelect name={modalPayload.id} config={modalPayload.config} isMulti />
              )}
              {modalPayload.config.type === FilterTypes.SELECT && (
                <FilterSelect name={modalPayload.id} config={modalPayload.config} />
              )}
              {modalPayload.config.type === FilterTypes.DATE && (
                <FilterDate name={modalPayload.id} config={modalPayload.config} />
              )}
              {modalPayload.config.type === FilterTypes.DATE_RANGE && <FilterDateRange name={modalPayload.id} config={modalPayload.config} />}
              {modalPayload.config.type === FilterTypes.EMAIL && (
                <FilterEmail name={modalPayload.id} config={modalPayload.config} />
              )}
              {modalPayload.config.type === FilterTypes.INPUT && (
                <FilterInput name={modalPayload.id} config={modalPayload.config} />
              )}
              {modalPayload.config.type === FilterTypes.CUSTOM && (
                <modalPayload.config.component {...modalPayload.config.optionComponent} name={modalPayload.id} />
              )}
              {modalPayload.config.type === FilterTypes.MULTI_CHECK && (
                // @ts-ignore
                <FilterListCheck name={modalPayload.id} config={modalPayload.config} />
              )}
              {/*{modalPayload.config.type === FilterTypes.SELECT_PATIENT && (*/}
              {/*  <FilterSelectPatient name={modalPayload.id} config={modalPayload.config} />*/}
              {/*)}*/}
              {/*{modalPayload.config.type === FilterTypes.SELECT_USER && (*/}
              {/*  <FilterSelectUser name={modalPayload.id} config={modalPayload.config} />*/}
              {/*)}*/}
              {/*{modalPayload.config.type === FilterTypes.SELECT_DATA_IN_EXAMS && (*/}
              {/*  <FilterSelectDataExams name={modalPayload.id} config={modalPayload.config} />*/}
              {/*)}*/}
              {/*{modalPayload.config.type === FilterTypes.SELECT_OBJECT_IN_EXAMS && (*/}
              {/*  <FilterSelectObjectExams name={modalPayload.id} config={modalPayload.config} />*/}
              {/*)}*/}
            </div>
            <div className="text-end mt-3">
              <Button onClick={closeModal} size="sm" outline>
                {t('Close')}
              </Button>
              <Button className="ms-1" type="submit" size="sm">
                {t('Add')}
              </Button>
            </div>
          </Form>
        </Formik>
      </div>
    </ModalDialog>
  );
}

export default TableModalFilters;
